import type { NetInfoState } from '@react-native-community/netinfo';

/** The slice of the NetInfo API the app actually uses. */
interface SafeNetInfo {
  addEventListener: (listener: (state: NetInfoState) => void) => () => void;
}

/**
 * `@react-native-community/netinfo` is a NATIVE module. On a dev client built
 * before it was linked, the plain `import … from '@react-native-community/netinfo'`
 * throws at require time («NativeModule.RNCNetInfo is null») and crashes the
 * whole app at startup (Veronika, iPhone dev build). Load it lazily inside a
 * try/catch — the same posture as registerLiveKit.native.ts — so the app
 * launches either way; network-state features degrade to a no-op until the next
 * native rebuild links RNCNetInfo.
 */
function loadNetInfo(): SafeNetInfo | null {
  try {
    return require('@react-native-community/netinfo').default as SafeNetInfo;
  } catch {
    return null;
  }
}

export const safeNetInfo = loadNetInfo();
